import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cloud-empty",
  "use": "icon-cloud-empty-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-cloud-empty\"><path d=\"M272 64H128v384h256V175.5zm0 22.6 89.8 89.4H272zM144 432V80h112v112h112v240z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol